import template from './wizard_start.html';
import tr from '../../lib/default-translator.js';

class WizardStartViewModel
{
	constructor (page)
	{
		this.page = page;
	}

	start_wizard()
	{
		if (!Grape.currentSession.roles.includes("admin"))
			Grape.alerts.alert({type: 'error', title: tr('Error', 'Error'), message: tr('Please sign in with an admin to pass the setup wizard.')});
		else
			Grape.dialog.open('WizardCompaniesEntry', {});
	}

	async skip_wizard()
	{
		if (!Grape.currentSession.roles.includes("admin")) 
			Grape.alerts.alert({type: 'error', title: tr('Error'), message: tr('Please sign in with an admin to pass the setup wizard.')});
		else
		{
			let result = await Grape.fetches.postJSON('/api/save_setting/', { name: 'system.wizard', value: false });
			if (result.status == 'ERROR')
			{
				Grape.alerts.apiError(result);
				return;
			}
		}
		Grape.navigate('/employee/list/0');
	}
}

class WizardStartPageNew
{
	constructor (bindings)
	{
		this.bindings = bindings;
		this.viewModel = new WizardStartViewModel(this);
	}

	init()
	{
		document.title = tr('Wizard Start');
		window.current_page_title(' ');
	}
}

export default {
	route: '[/]wizard/wizard_start',
	page_class: WizardStartPageNew,
	template: template,
	template_filename: 'translation/wizard_start'
};
